module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/pref-seller-o-99da5408a52642b615a46d7981ad0e7a.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/pref-seller-o.svg
// module id = xZ8y
// module chunks = 24